<template>
    <v-container grid-list-xl full-width fill-width>
        <v-layout wrap py-5>
            <v-flex xs12>
                <p>
                    Adicione os pseudônimo dos compostiores/autores das obras
                    <br />Se você precisar alterar o nome do compositor é necessário alterar direto no cadastro da obra.
                </p>
            </v-flex>

            <v-flex xs12 md12>
                <v-data-table
                    :headers="headers"
                    :items="tracks"
                    :items-per-page="50"
                    class="elevation-1"
                    hide-default-footer
                >
                    <template v-slot:item.works="{ item }">{{ item.works.length }}</template>
                    
                </v-data-table>
            </v-flex>
        </v-layout>
        {{tracks}}
    </v-container>
</template>
<script>
export default {
    props: {
        tracks: Array
    },
    data() {
        return {
            //titulares:[],
            //tabela
            headers: [
                { text: "Título da Faixa", value: "name" },
                { text: "Obras vinculadas", value: "works" }
            ]
        };
    },
    methods: {
        add_titular() {
            //adicionar uma validação dos campos aqui
            this.titular.indice = this.titulares.length + 1;
            this.titulares.push(JSON.parse(JSON.stringify(this.titular)));

            this.titular = {};
        }
    }
};
</script>